import { PropertyDescriptor } from "@yulintu/freesia-bootstrap";
export default PropertyDescriptor;